export const findRepeatedCodes = (orders, code) => {
  return orders.reduce((repeatedLines, element, index) => {
    if (element.partCode === code) {
      return [...repeatedLines, index + 1];
    }
    
    return repeatedLines;
  }, []);
};

export const getRepeatedIndex = (orders, code) => {
  return orders.findIndex((element) => element.partCode === code);
};
